"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";
import { useBlockableRouter } from "@/components/navigation-block";
import { useUserSummary } from "@/lib/api/user";
import { AuthenticationForm } from "../login/components/authentication-form";

// Dedicated onboarding entry point: sign up, then go straight into event
// creation. Unlike /login/signup this route hard-targets /event/new.
const NEXT = "/event/new";

export default function OnboardingPage() {
  const t = useTranslations();
  const router = useBlockableRouter();
  const { data: summary } = useUserSummary();

  // Returning, already-authenticated users skip signup entirely.
  useEffect(() => {
    if (summary?.user) {
      router.replace(NEXT, { ignoreBlocker: true });
    }
  }, [summary?.user, router]);

  const handleToggle = () => {
    router.push(`/login?next=${encodeURIComponent(NEXT)}`);
  };

  return (
    <div className="flex items-center justify-center h-full">
      <div className="flex w-full max-w-md flex-col gap-4">
        <div className="text-center">
          <h1 className="text-2xl font-semibold">{t("onboarding.title")}</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            {t("onboarding.subtitle")}
          </p>
        </div>
        <AuthenticationForm authType="signup" onToggleMethod={handleToggle} next={NEXT} />
      </div>
    </div>
  );
}
